const update_unit = async (inputs) => {
    const rowId = inputs.id;
    const response = await axios.patch(
        `/unitsResources/${rowId}`,
        inputs,
    );
    return response;
}  

const delete_unit = async (id) => {
    const response = await axios.delete(`/unitsResources/${id}`);
    return response;
}

const get_data_unit = async (id) => {
    try {
        const response = await axios.get(`/unitsResources/${id}`);                 
        const res = response.data;
        if (res) { 
            let obj = {
                id: res.id,
                code : res.code,
                factor : res.factor 
            }
            return obj;         
        }
    } catch (error) {
        console.error('Error fetching unit:', error);
        return false;
    } 
}



export { get_data_unit, update_unit, delete_unit };